<template>
  <v-snackbar
    v-model="showUpdatePrompt"
    :timeout="-1"
    location="bottom"
    color="primary"
    elevation="24"
  >
    <div class="d-flex align-center">
      <v-icon
        :icon="mdiDownload"
        class="mr-3"
      />
      <div>
        <div class="text-subtitle-2">
          {{ t('pwa.updateAvailable') }}
        </div>
        <div class="text-caption">
          {{ t('pwa.updateDescription') }}
        </div>
      </div>
    </div>

    <template #actions>
      <v-btn
        variant="text"
        @click="dismissUpdate"
      >
        {{ t('pwa.later') }}
      </v-btn>
      <v-btn
        variant="tonal"
        color="white"
        :loading="isUpdating"
        @click="updateApp"
      >
        {{ t('pwa.reload') }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
import { mdiDownload } from '@mdi/js'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

interface Props {
  show: boolean
}

const props = defineProps<Props>()

interface Emits {
  (e: 'update'): void
  (e: 'dismiss'): void
}

const emit = defineEmits<Emits>()

const showUpdatePrompt = computed({
  get: () => props.show,
  set: (value) => {
    if (!value) emit('dismiss')
  }
})

const isUpdating = ref(false)

const updateApp = () => {
  isUpdating.value = true
  emit('update')
}

const dismissUpdate = () => {
  emit('dismiss')
}
</script>
